import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/yoko/renehuemer.com/website/node_modules/next/dist/client/app-dir/link.js");
